import { render, staticRenderFns } from "./StartMobile.vue?vue&type=template&id=b212fde4&scoped=true"
import script from "./StartMobile.vue?vue&type=script&lang=js"
export * from "./StartMobile.vue?vue&type=script&lang=js"
import style0 from "./StartMobile.vue?vue&type=style&index=0&id=b212fde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b212fde4",
  null
  
)

export default component.exports